export default __webpack_public_path__ + "static/media/Gallery-9.a50d5bbb.jpeg";